import { render, staticRenderFns } from "./editPromoProvider.vue?vue&type=template&id=3ea36ec4&lang=pug"
import script from "./editPromoProvider.vue?vue&type=script&lang=js"
export * from "./editPromoProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports